// * |------------------------------------------|
// * | 🅶🅻🅾🅱🅰🅻 🆂🆃🆈🅻🅴🆂 - Глобальные стили |
// * |------------------------------------------|

// !deprecated 𝒔𝒕𝒚𝒍𝒆𝒔 𝒓𝒆𝒔𝒆𝒕 - проблема изоляции (приоритет специфичности)
// @import "./lib/reset";

// * 𝒗𝒂𝒓𝒔
@use "./lib/_vars" as *;

// * 𝒔𝒕𝒚𝒍𝒆𝒔
@use "./lib/_vSelect" as *;

// * 𝒔𝒕𝒚𝒍𝒆𝒔
@use "./lib/_helpers" as *;

// * 𝒇𝒐𝒏𝒕𝒔
@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@400;700&display=swap");

// * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [TradeIn Widget]
.tiw {
    &__hidden {
        visibility: hidden;
    }

    --custom-font-family: #{$manrope-family};
    --custom-font-size: 14px;
    --custom-color-text: #000;
    --custom-color-main: #ffe600;
    --custom-color-gray: #808d9a;
    --light-green-background: rgba(238, 248, 241, 1);
    --main-green: #009138;

    font-family: var(--custom-font-family);
    font-size: calc(var(--custom-font-size) * 1.143); // 14px -> 16px
    line-height: 1.5;
    color: var(--custom-color-text);

    &__link {
        color: #297bf6;
        font-size: calc(var(--custom-font-size) * 0.857); // 14px -> 12px
        cursor: pointer;
        font-style: normal;
        font-weight: 400;
        line-height: 1.333; /* 133.333% */
        transition:
            color,
            150ms ease;

        &:hover {
            color: #297bf6;
        }
    }

    input {
        font-family: $manrope-family;
    }

    button {
        font-family: $manrope-family;
    }

    * {
        box-sizing: border-box;
    }

    &__modal {
        background-color: #fff;
        border-radius: 20px;
        margin: auto;
        position: relative;

        @media screen and (max-width: 767px) {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            // min-height: 100%;
            margin: unset;
            margin-top: auto;
            max-width: none;
            width: 100%;
        }
    }

    &__title {
        font-size: calc(var(--custom-font-size) * 1.143); // 14px -> 16px
        font-weight: 700;
        line-height: 1.25; /* 125% */
        margin-bottom: 4px;
    }

    &__text {
        font-size: calc(var(--custom-font-size) * 1); // 14px -> 14px
        font-weight: 400;
        line-height: 140%; /* 19.6px */
        margin: 0;
        margin-bottom: 4px;
    }

    &__ul {
        line-height: 140%;
        margin-top: 0;
        margin-bottom: 16px;

        li {
            &:not(:last-child) {
                margin-bottom: 4px;
            }
        }

        &_disc {
            list-style-type: disc;
            padding-left: 16px;
        }
    }

    // * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [Icon]
    &__icon {
        display: inline-block;
        transition: transform 150ms ease;

        * {
            transition: all 150ms ease;
        }

        &_up {
            transform: rotate(-90deg);
        }

        &_down {
            transform: rotate(90deg);
        }

        &_left {
            transform: rotate(180deg);
        }

        // default direction
        &_right {
            transform: rotate(0);
        }
    }
}
